import React, {useContext, useEffect, useState} from "react";
import {DynamicComponentProps} from "../../core/_models";
import {Checkbox, FormControlLabel, FormGroup} from "@mui/material";

export function CheckboxComponent({context, config: {value, readOnly, id, onChange: action, title}}: DynamicComponentProps) {
    const formContext = useContext(context);
    const [v, setValue] = useState(value);

    useEffect(() => {
        formContext.set(id, v)
    }, [value])

    return (
        <FormGroup>
            <FormControlLabel
                control={
                    <Checkbox disabled={readOnly} checked={v} onChange={(e) => {
                        const newValue = !v;
                        setValue(newValue)
                        formContext.set(id, newValue)

                        if (action != null) {
                            const empty = {};
                            formContext.submit({action, empty})
                        }
                    }} value={id}/>
                }
                label={title}
            />
        </FormGroup>
    )
}